import { inBrowser } from './browser';

export function id() {
  return Math.random()
    .toString(36)
    .slice(2, 16);
}

export function examDiffProUrl(referrer) {
  return `https://www.prestosoft.com/edp_examdiffpro.asp?ref=${referrer}`;
}

export function toDateString(date) {
  const dateObject = new Date(date);
  return `${dateObject.toLocaleDateString()} ${dateObject.toLocaleTimeString()}`;
}

export const isPremium = user => !!(user && user.isPremium);

export function comparisonLimit(user, configuration, isAdblockEnabled = false) {
  const {
    comparisonCountLimitNotLoggedInMax,
    comparisonCountLimitLoggedInMax,
    comparisonCountLimitAdblockMax,
    monthlyComparisonCountLimitMax,
    monthlyComparisonCountLimitLoggedInMax,
    monthlyComparisonCountLimitAdblockMax,
    useMonthlyComparisonLimits
  } = configuration;

  if (isPremium(user)) {
    return Infinity;
  }

  if (isAdblockEnabled) {
    return useMonthlyComparisonLimits
      ? monthlyComparisonCountLimitAdblockMax
      : comparisonCountLimitAdblockMax;
  }

  if (useMonthlyComparisonLimits) {
    return user ? monthlyComparisonCountLimitLoggedInMax : monthlyComparisonCountLimitMax;
  }
  return user ? comparisonCountLimitLoggedInMax : comparisonCountLimitNotLoggedInMax;
}

export function registrationRaisesLimit(configuration) {
  return (
    comparisonLimit({ isPremium: false }, configuration) > comparisonLimit(null, configuration)
  );
}

export function canUserCompare(
  comparisonCount,
  user,
  configuration,
  logEvent = null,
  isAdblockEnabled = false
) {
  if (comparisonCount < comparisonLimit(user, configuration, isAdblockEnabled)) {
    return true;
  } else {
    if (logEvent) {
      logEvent('COMPARISON_LIMIT_REACHED', {
        comparisons_this_month: comparisonCount,
        limit: comparisonLimit(user, configuration, isAdblockEnabled)
      });
    }
    return false;
  }
}

export function isBrowserUnsupported() {
  require('../lib/modernizr.js'); // eslint-disable-line
  const { Modernizr } = window;
  return inBrowser() && !(Modernizr.es5 && Modernizr.flexbox && Modernizr.localstorage);
}

export const sleep = async ms => new Promise(resolve => setTimeout(resolve, ms));
